// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  padding-top: 15px;
  padding-left: 15px;
  background-color: #efeff7;
}
.brblue.text-lg {
  padding-bottom: 15px;
}
.user-prop {
  padding: 10px 20px;
}
.user-prop i {
  cursor: pointer;
  font-size: 16px;
  padding-right: 20px;
}
.col-4 {
  padding-right: 20px;
}
#userClientAssignment {
  margin-left: 10px !important;
  max-width: 64.5% !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/users-module/users-add/users-add.component.less"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;AADF;AAGA;EACE,oBAAA;AADF;AAGA;EACE,kBAAA;AADF;AAGA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;AADF;AAGA;EACE,mBAAA;AADF;AAIA;EACE,4BAAA;EACA,2BAAA;AAFF","sourcesContent":["@import (reference) '../../../styles.less';\n\nform {\n  padding-top: 15px;\n  padding-left: 15px;\n  background-color: @ltpurple;\n}\n.brblue.text-lg {\n  padding-bottom: 15px;\n}\n.user-prop {\n  padding: 10px 20px;\n}\n.user-prop i {\n  cursor: pointer;\n  font-size: 16px;\n  padding-right: 20px;\n}\n.col-4 {\n  padding-right: 20px;\n}\n\n#userClientAssignment {\n  margin-left: 10px !important;\n  max-width: 64.5% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
